<script>
    import { afterUpdate, createEventDispatcher, onMount } from "svelte";
    import SearchList from "./SearchList.svelte";

    const dispatch = createEventDispatcher();

    let visible = false;

    export let list = []
    export let columns = null;
        
    function onCancel() {
        visible = false;
        dispatch('cancel', {});
    }

    function onItemSelected(evt) {
        visible = false;
        dispatch('itemSelected', evt.detail);
    }

    function onItemHover(evt) {
        dispatch('itemHover', evt.detail);
    }

    function onItemOut() {
        dispatch('itemOut', {})
    }

    export const show = () => {
        visible = true;
    }
    export const hide = () => visible = false;

</script>

{#if visible}
    <section>
        <div>
            <SearchList
                bind:list
                columns={columns}
                on:cancel={onCancel}
                on:itemSelected={onItemSelected}
                on:itemHover={onItemHover}
                on:itemOut={onItemOut} />
        </div>
    </section>
{/if}

<style>
    section {
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0px;
        left: 0px;
        margin-left: auto;
        margin-right: auto;
        z-index: 100;
        background-color: rgba(0, 0, 0, 0.4);
    }

    div {
        position: absolute;
        width: 80vw;
        top: 10vh;
        left: 10vw;
        background-color: white;
        padding: 25px;
        height: 40vh;
        min-height: 300px;
        border-radius: 10px;
        margin-right: auto;
        margin-left: auto;
    }
</style>

